import Navbar from '../components/Navbar';
import Footer from 'components/Footer';
import { useSelector } from "react-redux";
import MobileNavbar from 'components/MobileNavbar';
import MobileFooter from 'components/MobileFooter';

import Membership from 'components/BKantarciService/Membership';

function ServiceMembership() {

  const isMobile = useSelector(state => state.windowSize.isMobile);

  return (
    <>
    {isMobile ? (
      <>
        <MobileNavbar />
        <Membership />
        <hr />
        <MobileFooter />
      </>
    ) : (
      <>
        <Navbar />
        <Membership />
        <hr />
        <Footer />
      </>
    )}
    </>
  );
}

export default ServiceMembership;
